<template>
  <div data-qa="popup-layout-body">
    <slot name="prepend" />
    <div v-if="hasBody()" :class="$style.body">
      <div
        :class="[
          $style.main,
          { [$style.fullWidth]: singleColumn },
          { [$style.clearPadding]: paddingDisabled }
        ]"
        ><slot name="main"
      /></div>
      <div v-if="!singleColumn" :class="$style.side"><slot name="side" /></div>
    </div>
    <slot name="append" />
  </div>
</template>

<script>
import { SlotChecker } from '@/util/slot-checker';

export default {
  name: 'VBody',
  props: {
    singleColumn: {
      type: Boolean,
      default: false
    },
    paddingDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasBody() {
      return (
        SlotChecker.isSlotNotEmpty(this.$slots.main) || SlotChecker.isSlotNotEmpty(this.$slots.side)
      );
    }
  }
};
</script>

<style lang="less" module>
@import '~@less/common/variables.less';

@sideWidth: 261px;

.body {
  display: flex;
}

.main {
  flex-grow: 1;
  padding: 15px 20px 10px 0;
  position: relative;
  box-sizing: border-box;
  max-width: calc(100% - @sideWidth);
}

.clearPadding {
  padding: 0;
}

.fullWidth {
  padding-right: 0;
  max-width: 100%;
}

.side {
  flex: none;
  padding: 15px 0 20px 20px;
  width: @sideWidth;
  position: relative;
  box-sizing: border-box;
  border-left: 1px solid @borderColor;
  &:empty {
    border: none;
  }
}
</style>

<i18n lang="json" />
